import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';
import { isAdminDashboard } from 'utils/authScopes';
import Tooltip from 'rc-tooltip';

const NameOrAll = ({ name }) => {
  const { t } = useTranslation();
  if (name !== null) {
    return <span>{name}</span>;
  }

  return (
    <Tooltip
      placement="top"
      overlay={(
        <span>
          {t('groupCohortsRow.allTooltip')}
        </span>
      )}
    >
      <span>{t('groupCohortsRow.all')}</span>
    </Tooltip>
  )
}

NameOrAll.propTypes = {
  name: PropTypes.string,
}

const GroupCohortsRow = ({ auth, data, meta }) => {
  let fontWeight = 'normal';
  if (meta.withcohorts) {
    fontWeight = data.groupId === null || data.subgroupId === null || data.cohortId === null ? 'bold' : 'normal';
  } else {
    fontWeight = data.groupId === null ? 'bold' : 'normal';
  }

  const cells = meta.withages ? map(data.childrenSizeByAge, (v, k) => (
    <td key={`${data.groupId}-${data.subgroupId}-${data.cohortId}-${k}`}>{v.size}</td>)) : null;
  return (
    <tr style={{ fontWeight }}>
      { isAdminDashboard(auth) && <td>{data.partner}</td> }
      <td>
        <NameOrAll name={data.groupName} />
      </td>
      { meta.withcohorts && (
        <>
          <td>
            <NameOrAll name={data.subgroupName} />
          </td>
          <td>
            <NameOrAll name={data.cohortName} />
          </td>
        </>
      ) }
      <td>{data.childrenSize}</td>
      { cells }
      <td>{data.activeChildren}</td>
      <td>{data.engagedChildren}</td>
      <td>{data.completedAsqSe2Count}</td>
      <td>{data.completedAsq3Count}</td>
      <td>{data.totalPlays}</td>
      <td>{data.totalPhotos}</td>
    </tr>
  );
}

GroupCohortsRow.propTypes = {
  auth: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default GroupCohortsRow;
